// extracted by mini-css-extract-plugin
export default {"add":"Tags_add__KDKBs","input":"Tags_input__w3Sk3"};